import { HowWeKnow } from './HowWeKnow'
import type { CoplayData } from '@/types'

interface GroupHoursStatProps {
  coplay: CoplayData
}

function fmtH(h: number): string {
  if (h < 1) return `${Math.round(h * 60)}m`
  return `${h < 10 ? h.toFixed(1).replace(/\.0$/, '') : Math.round(h)}h`
}

export function GroupHoursStat({ coplay }: GroupHoursStatProps) {
  const signals = [
    `${coplay.sessions.length} co-play session${coplay.sessions.length === 1 ? '' : 's'} inferred since group started`,
    ...new Set(coplay.sessions.flatMap((s) => s.signals)),
  ]
  return (
    <div className="cg-pt-stat">
      <div className="cg-pt-stat-num">
        <span className="cg-pt-tilde">~</span>
        {fmtH(coplay.totalGroupHours)}
        <HowWeKnow signals={signals} confidence={coplay.avgConfidence} />
      </div>
      <div className="cg-pt-stat-label">estimated together</div>
    </div>
  )
}
